<template>
  <div class="step-page-sheet">
    <Transition
      mode="out-in"
      enter-active-class="transition-opacity duration-200 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-150 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <StepLoadingSkeleton v-if="isLoading" key="loading" variant="cart" />
      <div v-else key="content" class="p-6 lg:px-8 lg:pt-4 lg:pb-8">
      <OrderPaidBanner :lock-reason="lockReason" />
      <p class="font-medium text-center text-dark-gray mb-6 lg:text-base">
        {{
          orderId == null
            ? "Tu carrito está vacío. Vuelve al paso 2 para cargar productos."
            : "Revisá que tus productos estén cargados correctamente antes de guardar tu suscripción."
        }}
      </p>
      <div class="flex flex-col lg:grid lg:grid-cols-2 gap-3 lg:gap-4">
        <div v-for="prod in cart" :key="prod.id" class="text-sm text-gray-700">
          <div
            v-if="prod.quantity"
            class="flex justify-between rounded-lg border border-light-gray overflow-hidden bg-white"
          >
            <div
              v-if="editSubscription"
              class="bg-red-warning rounded-l-lg flex flex-col justify-center p-1 text-white opacity-60 transition-all ease-in-out duration-500 cursor-pointer"
              @click="removeFromCart(prod)"
            >
              <img src="icons/times-circle.svg" alt="" class="w-4 h-4" />
            </div>
            <div class="p-2 w-3/4">
              <div
                :title="prod.ecommerceName"
                class="flex p-1 font-semibold text-base lg:text-base"
              >
                {{ prod.ecommerceName }}
              </div>
              <div class="flex items-baseline font-semibold">
                <p class=" p-1 font-light lg:">Total:</p>
                <p class="flex-grow text-base lg:text-base lg:flex-grow-0">
                  ${{ prod.unitPrice * prod.quantity }}
                </p>
                <span class="relative inline-block">
                  <span
                    class="absolute -top-2 right-0 inline-flex items-center justify-center h-4 w-6 text-xs font-bold leading-none text-dark-gray bg-light-gray transform translate-x-1/2 -translate-y-1/2 rounded-lg lg:left-0 lg: lg:w-8 lg:h-6 "
                    >x{{ prod.quantity }}</span
                  >
                </span>
              </div>
            </div>
            <div class="w-1/4 flex justify-end">
              <img
                v-if="!!prod.image"
                :src="prod.image"
                class="rounded-r-lg h-20 w-16 lg:h-28 lg:w-20"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-center mt-6">
        <div
          class="flex items-baseline justify-center bg-light-gray px-4 py-2 rounded-lg gap-2 truncate"
        >
          Total Suscripción:
          <p class="text-base font-semibold lg:text-lg">${{ total }}</p>
        </div>
        <div class="mt-6 flex flex-col gap-3">
        <button
          v-if="isEditable && total != 0 && !editSubscription"
          type="button"
          class="btn-primary lg:text-lg"
          @click="startEdit"
        >
          Editar Suscripción
        </button>
        <button
          v-if="editSubscription"
          type="button"
          class="btn-primary lg:text-lg"
          @click="createSubscription"
        >
          Guardar Suscripción
        </button>
        <button
          v-if="isEditable && cart.length > 0 && !editSubscription"
          type="button"
          class="btn-primary lg:text-lg"
          @click="this.$emit('changeStep', 5)"
        >
          Pagar Suscripción
        </button>
        <button
          v-else-if="!editSubscription"
          type="button"
          class="btn-muted lg:text-lg"
          disabled
        >
          Guardar Suscripción
        </button>
        </div>
      </div>
      </div>
    </Transition>
  </div>
</template>

<script>
  import { ref, inject, watch } from "vue";
  import axios from "axios";
  import StepLoadingSkeleton from "./StepLoadingSkeleton.vue";
  import OrderPaidBanner from "./OrderPaidBanner.vue";

  export default {
    components: {
      StepLoadingSkeleton,
      OrderPaidBanner,
    },
    props: {
      authenticatedUser: { type: Object, default: () => ({}) },
      orderId: { type: Number, default: null },
      isEditable: { type: Boolean, default: false },
      lockReason: { type: String, default: null },
    },
    setup(props) {
      const isShowBancos = ref(false);
      const isLoading = ref(true);
      const isOpen = ref(false);
      const cart = ref([]);
      const total = ref(0);
      const editSubscription = ref(false);
      const globalState = inject("globalState");

      const getCart = async () => {
        isLoading.value = true;
        try {
          const { data: periodData } = await axios.get("Periods/getCurrent");
          const { data: products } = await axios.get(
            `Products/byOrder?periodId=${periodData.periodId}${
              props.orderId == null ? "" : `&orderId=${props.orderId}`
            }`
          );
          cart.value = products
            .filter((x) => x.quantity != 0)
            .sort((a, b) => {
              if (a.Sequence > b.Sequence) return 1;
              if (a.Sequence < b.Sequence) return -1;
              return 0;
            });
          total.value = cart.value.reduce(
            (acc, curr) => acc + curr.unitPrice * curr.quantity,
            0
          );
        } catch (err) {
          console.log(err.response);
        } finally {
          isLoading.value = false;
        }
      };

      // ✅ Vuelve a llamar a getprovinces si se actualiza el token
      watch(
        () => globalState.tokenUpdated,
        (newVal) => {
          if (newVal === true) {
            console.log("Token actualizado. Reconsultando carrito...");
            getCart();
            globalState.tokenUpdated = false; // Reinicia la bandera para futuras actualizaciones
          }
        }
      );

      getCart();

      return {
        isShowBancos,
        isLoading,
        cart,
        total,
        isOpen,
        editSubscription,
        startEdit() {
          editSubscription.value = true;
        },
        finishEdit() {
          editSubscription.value = false;
        },
        closeModal() {
          isOpen.value = false;
        },
        openModal() {
          getCart();
          setTimeout(() => {
            isShowBancos.value = false;
            isOpen.value = true;
          }, 1000);
        },
        removeFromCart(prod) {
          prod.quantity = 0;
          prod.amount = 0;
          this.total = this.cart.reduce((acc, curr) => acc + curr.amount, 0);
        },
        async createSubscription() {
          this.finishEdit();
          await axios
            .put(
              `Orders/upsert?orderId=${props.orderId}
          &subscriptorId=${props.authenticatedUser.clientId}`,
              cart.value
            )
            .then(() => {
              this.openModal();
            })
            .catch((err) => console.log(err.response));
        },
      };
    },
  };
</script>
